export default __webpack_public_path__ + "static/media/Google_Play_Store_badge.c2a8c7e5.svg";